import React from 'react';
import PropTypes from 'prop-types';
import s from './PoiSheet.module.scss';

const JsonEditor = ({ poi }) => (
    <div className={s.editorGroup}>
        <pre>{JSON.stringify(poi, 0, 2)}</pre>
    </div>
);

JsonEditor.propTypes = { poi: PropTypes.object };

JsonEditor.defaultProps = { poi: {} };

export default JsonEditor;
